module.exports = __webpack_public_path__ + "static/NewJune-regular-d1bfd30f3add3a20c6d38fe085179c9e.woff";